<template>
  <div class="full-height d-flex flex-column ">
    <pc-header></pc-header>
    <div class="container">
      <div class="row m-0 p-0">

        <div class="col-12">
          <h2>
            Pricing
          </h2>
          <div class="mt-4">14 days of trial are available for <span class="font-weight-bold">free</span> after registration of account. <span class="text-secondary">No credit card required.</span> </div>
          <div class="mt-4">If you decided to purchase a license, following options are available:</div>
        </div>
        <div class="col-12 col-sm-6 mt-4 ">
          <div class="licence-option">
            <div class="licence-option__title">
              Monthly License
            </div>
            <div class="licence-option__price mt-5">
              $4.99 <span class="licence-option__price--small">/ month</span>
            </div>
            <div class="licence-option__start mb-4">
              <router-link :to="call_to_action_link">
                <el-button>{{call_to_action_text}}</el-button>
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6  mt-4 mb-5">
          <div class="licence-option licence-option--year">
            <div class="licence-option__title licence-option__title--year">
              <span class="licence-option__title-text">Yearly License</span>
            </div>
            <div class="licence-option__price mt-5">
              $49.99 <span class="licence-option__price--small">/ year</span>
            </div>
            <div class="licence-option__save px-3 mt-1">Save $10 by purchasing an yearly licence</div>
            <div class="licence-option__start mb-4">
              <router-link :to="call_to_action_link">
                <el-button>{{call_to_action_text}}</el-button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <pc-footer></pc-footer>
  </div>

</template>

<script>
  import PcHeader from '../components/pc-header.component'
  import PcFooter from '../views/PcFooter'
  import {mapState} from 'vuex'
  export default {
    name: 'pricing',
    components: {
      PcFooter,
      PcHeader},
    computed: {
      ...mapState(['is_logged_in']),
      call_to_action_text () {
        if (this.is_logged_in) {
          return 'Buy Now'
        }
        return 'Register Now'
      },
      call_to_action_link () {
        if (this.is_logged_in) {
          return 'my-profile'
        }

        return 'sign-up'
      }
    },
  }
</script>

<style scoped>
  .full-height {
    min-height: 100vh;
    flex-direction: column;
  }
  .licence-option {
    width: 250px;
    height: 300px;
    /*background: linear-gradient(105.43deg, #B1FA79 0%, #EBE102 100%);*/
    box-shadow: 0px 3px 4px rgba(191, 205, 227, 0.25);
    border-radius: 3px;
    text-align: center;
    /*padding: 1em;*/
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    background-color: #ffffff;
  }
  @media (max-width: 768px) {
    .licence-option {
      width: 100%;
      /*height: 350px;*/
    }
  }
  .licence-option--year {
    /*background: linear-gradient(141.03deg, #59B4D0 0%, #4989D5 100%);*/
    /*box-shadow: 0px 2px 5px rgba(73, 137, 212, 0.25);*/
    /*background: linear-gradient(171.44deg, #59A5D0 0%, #8F49D5 159.48%);*/
  }

  .licence-option {
    font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif;
  }

  .licence-option__title {
    font-size: 1.2em;
    font-weight: 500;
    color: #1d2125;
    padding-top: 1em;
    padding-bottom: 1em;
    background: linear-gradient(105.43deg, #B1FA79 0%, #EBE102 100%);
    display: block;
    width: 100%;
    border-radius: 3px 3px 0 0;
  }
  .licence-option__title--year {
    background: linear-gradient(171.44deg, #59A5D0 0%, #8F49D5 159.48%);
    color: #ffffff;
  }
  .licence-option__price {
    font-weight: 500;
    font-size: 1.5em;
  }
  .licence-option__price--small {
    font-weight: normal;
    font-size: 0.6em;
  }

  .licence-option__start {
    margin-top: auto;
  }
  .licence-option__save {
    font-size: 0.7em;
    color: #272a2f;
    padding-top: 0.5em;
  }
</style>